import ClientsCard from "~/components/Metrics/ClientsCard";
import api from "~/api";
import { useTranslation } from "react-i18next";

const Clients = ({ siteId }: { siteId: string }) => {
  const { t } = useTranslation();
  const getClientMetrics = async (query: MetricsAPI.GetMetricQuery) => {
    try {
      const { data } = await api.metrics.getClientNetworkBySite({
        siteId,
        ...query,
      });
      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getClientsOnlineMetrics = async (params: MetricsAPI.GetMetricQuery) => {
    try {
      const { data } = await api.metrics.getClientOnlineBySite(params);

      if (data) {
        return data.data;
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <ClientsCard
      title={`${t("title.clientsBy")} ${t("text.site")}: ${siteId}`}
      onUpdate={getClientMetrics}
      onUpdateOnline={getClientsOnlineMetrics}
    />
  );
};

export default Clients;
